module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0120.jpg?v=521c7b9f";